import { Actions } from '../actions/options';
import { DeepReadonly } from 'utility-types';
import { IClientDashboardChartFilter } from 'src/interfaces/clientDashboardChartFilter';

export const createReducer = <T>(initialState: T) => (
  state = { ...commonInitialState, ...initialState },
  action: Actions
): State & T => {
  switch (action.type) {
    case 'GET_OPTIONS':
      return {
        ...state,
        ...action.options,
        isLoaded: true
      };
    case 'SET_OPTION':
      return {
        ...state,
        ...action.option
      };
    default:
      return state;
  }
};

export type State = DeepReadonly<{
  isLoaded: boolean;
  dismissOrganizationLink: boolean;
  navExpanded: boolean;
  navExpandedSectionIds: string[];
  clientDashboardScoreSetId: string;
  clientDashboardPrequalGroups: IClientDashboardChartFilter[];
  clientDashboardIncludedTags: IClientDashboardChartFilter[];
  clientDashboardExcludedTags: IClientDashboardChartFilter[];
}>;

const commonInitialState: State = {
  isLoaded: false,
  dismissOrganizationLink: false,
  navExpanded: true,
  navExpandedSectionIds: [],
  clientDashboardScoreSetId: '',
  clientDashboardPrequalGroups: [],
  clientDashboardIncludedTags: [],
  clientDashboardExcludedTags: []
};

export const reducer = createReducer({});
